import SocketWorker from "./SocketWorker"
export { disconnectSocket, refreshSocketToken } from "./SocketWorker";

export function socketConnection(params) {
  return SocketWorker(params?.user?.companyId ?? params?.companyId, params?.user?.id ?? params?.userId);
}
